import FileUploaderV2ListItem from '@core/components/ApplyDialogV2/FileUploaderV2ListItem'
import React, { type FC } from 'react'
import './FileUploaderV2List.scss'

const baseClass = 'FileUploaderV2List'

interface FileUploaderV2ListProps {
    files: File[]
    fileErrors?: { file: File; error: string }[]
    onDelete?: (file: File) => void
    oldCv?: boolean
}

const FileUploaderV2List: FC<FileUploaderV2ListProps> = ({
    fileErrors = [],
    files,
    onDelete,
    oldCv = false }) => {
    return (
        <div className={baseClass}>
            {files.map((file, index) => {
                const error = fileErrors.find((err) => err.file === file)?.error
                return (
                    <React.Fragment key={index}>
                        <FileUploaderV2ListItem
                            file={file}
                            fileError={error}
                            onDelete={onDelete}
                            oldCv={oldCv}
                        />
                        {!error || oldCv && (
                            <div className={`${baseClass}__cv-parse-info`}>
                                <div className={`${baseClass}__cv-parse-title`}>
                                    Would you like to automatically parse your CV?
                                </div>
                                <div className={`${baseClass}__cv-parse-desc`}>
                                    Information from your CV file can be automatically parsed to fill in the details in the following steps (your profile as well).
                                    You will be able to add or edit any information at any time.
                                </div>
                                <div className={`${baseClass}__cv-parse-radio-group`}>
                                    <label className={`${baseClass}__cv-parse-radio`}>
                                        <input type="radio" name="cv-parse" value="yes" defaultChecked /> Yes
                                    </label>
                                    <label className={`${baseClass}__cv-parse-radio`}>
                                        <input type="radio" name="cv-parse" value="no" /> No, I'll add information myself
                                    </label>
                                </div>
                            </div>
                        )}
                    </React.Fragment>
                )
            })}
        </div>
    )
}

export default FileUploaderV2List